var Formation_video = {
    init:function(){
        var swiper = new Swiper(".block-video-and-citation .swiper-container-video", {
            slidesPerView:'auto',
            spaceBetween: 20,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              },
            breakpoints: {
                
                1040: {
                    spaceBetween: 40,
                }
              }
          });
    }
}

$(window).load(function(){
    if($('.block-video-and-citation').length){
        Formation_video.init();
    }
})